import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    width: 100%;
    height: 100%;
    /* v1.0.111 — defesa contra zoom acidental no Tab A7.
       touch-action: manipulation desabilita double-tap-to-zoom no Android
       WebView; touch-action: none impediria scroll/click, então mantemos
       manipulation. Combinado com setSupportZoom(false) no MainActivity. */
    touch-action: manipulation;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
    overscroll-behavior: none;
    /* v1.0.112 → v1.0.114: overflow hidden mantido, mas REMOVIDO o
       position:fixed no html/body (regressão potencial — body com
       position:fixed pode complicar containing block de descendentes
       fixed). Mantemos só overflow:hidden + as defesas de zoom. */
    overflow: hidden !important;
  }

  html {
    font-size: 16px;
  }

  body {
    overflow: hidden;
    font-family: 'Roboto', 'Helvetica Neue', Arial, sans-serif;
    background-color: #121212;
    color: #FFFFFF;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #root {
    width: 100%;
    height: 100%;
  }

  /* TV Focus Styles */
  *:focus {
    outline: none;
  }

  .focusable {
    transition: transform 150ms ease-in-out, box-shadow 150ms ease-in-out;
  }

  .focusable:focus {
    transform: scale(1.05);
    box-shadow: 0 0 0 4px rgba(79, 195, 247, 0.5);
  }

  /* Hide scrollbars for TV */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Button base styles for TV */
  button {
    cursor: pointer;
    border: none;
    background: transparent;
    font-family: inherit;
  }

  button:focus {
    outline: none;
  }

  /* Links */
  a {
    text-decoration: none;
    color: inherit;
  }

  /* Lists */
  ul, ol {
    list-style: none;
  }

  /* Images */
  img {
    max-width: 100%;
    height: auto;
  }

  /* =========================================
     HIDE NATIVE WEBKIT VIDEO CONTROLS
     =========================================
     Android WebView renders native video controls by default.
     These pseudo-elements hide the grey play button that appears
     during video transitions on Android devices.
     Reference: github.com/ionic-team/capacitor/discussions/3510
  */
  video::-webkit-media-controls,
  video::-webkit-media-controls-panel,
  video::-webkit-media-controls-play-button,
  video::-webkit-media-controls-overlay-play-button,
  video::-webkit-media-controls-start-playback-button,
  video::-webkit-media-controls-enclosure {
    display: none !important;
    -webkit-appearance: none !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }

  /* Fallback for some Android versions */
  video::-webkit-media-controls-container {
    display: none !important;
  }
`;

export default GlobalStyles;
